import { render, staticRenderFns } from "./EnhancedBuildingTable.vue?vue&type=template&id=a406cb7e&scoped=true&"
import script from "./EnhancedBuildingTable.vue?vue&type=script&lang=js&"
export * from "./EnhancedBuildingTable.vue?vue&type=script&lang=js&"
import style0 from "./EnhancedBuildingTable.vue?vue&type=style&index=0&id=a406cb7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a406cb7e",
  null
  
)

export default component.exports